module.exports = "<div class=\"cgp-live-feed-component cgp-live-feed-game-jackpot\">\r\n    <div class=\"cgp-live-feed-content\"></div>\r\n</div>";